<app-property-division-form [cnpjSeller]="true"></app-property-division-form>
